import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import { isTextarea } from 'customer-data-objects/property/PropertyIdentifier';
import refObject from 'UIComponents/utils/propTypes/refObject';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
export class PropertyInputExpandableText extends PureComponent {
  constructor(...args) {
    super(...args);

    this.handleChange = event => {
      if (!isTextarea(this.props.property)) {
        const value = event.target.value;

        if (event.target.value.includes('\n')) {
          // prevent newlines if not a textarea, for why we're doing this see https://git.hubteam.com/HubSpot/CRM-Issues/issues/4221
          return this.props.onChange(Object.assign({}, event, {
            target: Object.assign({}, event.target, {
              value: value.replace(/\n/g, '')
            })
          }));
        }
      }

      return this.props.onChange(event);
    };
  }

  render() {
    const {
      inputRef,
      value
    } = this.props;
    return /*#__PURE__*/_jsx(UIExpandableText, {
      buttonAlign: "left",
      hideButtonCaret: true,
      children: /*#__PURE__*/_jsx(UIExpandingTextArea, Object.assign({}, getTransferrableProps(this.props), {
        value: value === null ? '' : value,
        inputRef: inputRef,
        onChange: this.handleChange,
        shrink: true
      }))
    });
  }

}
PropertyInputExpandableText.propTypes = {
  onChange: PropTypes.func.isRequired,
  inputRef: refObject.isRequired,
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};
PropertyInputExpandableText.defaultProps = UIExpandingTextArea.defaultProps;
export default PropertyInputExpandableText;